import { useFormikContext } from "formik"
import { useEffect } from "react"

export function useBeforeUnloadForm(additionalCondition = false) {
    const { dirty, isSubmitting } = useFormikContext()

    useEffect(() => {
        if (!dirty && !additionalCondition) return

        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if ((dirty || additionalCondition) && !isSubmitting) {
                e.preventDefault()
            }
        }

        window.addEventListener("beforeunload", handleBeforeUnload)
        return () => window.removeEventListener("beforeunload", handleBeforeUnload)
    }, [dirty, isSubmitting, additionalCondition])
}
